import { render } from "./LeaveRequests.vue?vue&type=template&id=f2a9f13a"
import script from "./LeaveRequests.vue?vue&type=script&lang=js"
export * from "./LeaveRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__